import Service from "../Service";
const resource = "TasProducerDebt/";

export default {
  pagination(parameters, requestID) {
    return Service.post(resource + "pagination", parameters, {
      params: { requestID },
    });
  },
  detail(parameters, requestID) {
    return Service.post(resource + "detail", parameters, {
      params: { requestID },
    });
  },
  //   byID(parameters, requestID) {
  //     return Service.post(resource + "byId", parameters, {
  //       params: { requestID },
  //     });
  //   },
};
